export default __webpack_public_path__ + "static/media/searchIcon.9dadf8e2.svg";